import { USER_INFO } from "./actions";
const intialstate = {
  userInfo: {}
};

export default (state = intialstate, action) => {
  const newState = { ...state };
  console.log(action.payload)
  switch (action?.type) {
    case USER_INFO: {
      return { ...state, userInfo: action?.payload };
    }
    default: {
      return newState;
    }
  }
};

// export default userInforeducer;
